import OffersResponse from '../../services/offers/OffersReponse'
import OffersResponseRevamp from '../../services/offers/OffersResponseRevamp'
import OffersRegions from '@/services/offers/OffersRegions'
import CountriesAndCities from '@/services/offers/CountriesAndCities'

export default {
  offers: OffersResponse.empty(),
  slides: OffersResponseRevamp.empty(),
  regions: OffersRegions.empty(),
  countriesWithCities: CountriesAndCities.empty(),
  isSeeAllFilter: false,
  isSeeAllFilterEurope: false,
  emptySliders: false,
  registeredOfferCodes: [],
  locationOrRegion: ''
}
